import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface CreateAssemblyMappingInput {
    orderId: string;
    parentPartId: string;
    subPartIds: Array<string>;
}

const createAssemblyMapping = async (data: CreateAssemblyMappingInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/parts/assembly-mapping`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useCreateAssemblyMapping = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateAssemblyMappingInput) => createAssemblyMapping(data, sessionContext?.sessionId ?? null),
        onSuccess: (_data, { orderId }) => {
            queryClient.invalidateQueries({ queryKey: ['/order/detail', orderId] });
        },
    });
};
